// Auto-generated by scripts/generate-registry.mjs from packages/modules/teacher_20_11_round_medal/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const teacher_20_11_round_medal: ModuleSchema = {
  "id": "teacher_20_11_round_medal",
  "uniqueId": "B3D_164EQ",
  "createdAt": "2026-10-19T00:00:00Z",
  "updatedAt": "2026-10-21T11:50:20.086Z",
  "label": "Teacher 20-11 Clicker",
  "description": "Teacher tribute medal with a 40 mm round face, external hanger loop, raised rim, curved Vietnamese text, book, pen, and flower ornament",
  "category": "fidget",
  "tags": [
    "teacher-gift",
    "clicker",
    "mx-switch",
    "round",
    "teacher-gift"
  ],
  "sliders": [
    {
      "key": "size",
      "label": "Round Clicker Diameter",
      "min": 25,
      "max": 50,
      "default": 40,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1,
        2,
        3
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "textOffsetX",
      "label": "Text Position X",
      "min": -12,
      "max": 12,
      "default": 0.5,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "textOffsetY",
      "label": "Text Position Y",
      "min": -12,
      "max": 12,
      "default": 3.5,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "textWidthXY",
      "label": "Text Width (XY)",
      "min": 5,
      "max": 50,
      "default": 32,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "bookOffsetX",
      "label": "Book and Pen Position X",
      "min": -12,
      "max": 12,
      "default": 1,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        2
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "bookOffsetY",
      "label": "Book and Pen Position Y",
      "min": -12,
      "max": 12,
      "default": -1,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        2
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "bookScaleXY",
      "label": "Book and Pen Scale (XY)",
      "min": 0.5,
      "max": 1.5,
      "default": 1,
      "step": 0.05,
      "unit": "Ã—",
      "targetGroupIds": [
        2
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "flowersOffsetX",
      "label": "Flower Ornament Position X",
      "min": -12,
      "max": 12,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        3
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "flowersOffsetY",
      "label": "Flower Ornament Position Y",
      "min": -12,
      "max": 12,
      "default": -0.5,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        3
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "flowersScaleXY",
      "label": "Flower Ornament Scale (XY)",
      "min": 0.5,
      "max": 1.5,
      "default": 1.45,
      "step": 0.05,
      "unit": "Ã—",
      "targetGroupIds": [
        3
      ],
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Curved Text",
      "default": "MỪNG 20.11",
      "kind": "text",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "clicker_base",
      "label": "Round Clicker Base and Hanger",
      "default": "#123B63",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "mx_switch",
      "label": "MX Switch Simulation",
      "default": "#dc2626",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keycap",
      "label": "Round Keycap",
      "default": "#FFFFFF",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "teacher_decoration",
      "label": "Text, Book and Flowers",
      "default": "#123B63",
      "targetGroupIds": [
        3
      ]
    }
  ],
  "objects": [
    {
      "id": "clicker_base",
      "label": "Round Clicker Base",
      "name": "Round Clicker Base",
      "color": "#123B63",
      "assembled_z_offset": 0,
      "exploded_z_offset": 10,
      "parts": [
        {
          "id": "clicker_base",
          "label": "Round Clicker Base and Hanger",
          "name": "Round Clicker Base and Hanger",
          "groupId": 0,
          "colorKey": "clicker_base",
          "defaultColor": "#123B63",
          "assembled_z_offset": 0,
          "exploded_z_offset": 10,
          "export_stl": true
        }
      ]
    },
    {
      "id": "mx_switch",
      "label": "MX Switch",
      "name": "MX Switch",
      "color": "#dc2626",
      "assembled_z_offset": 0,
      "exploded_z_offset": 20,
      "parts": [
        {
          "id": "mx_switch",
          "label": "MX Switch Simulation",
          "name": "MX Switch Simulation",
          "groupId": 1,
          "colorKey": "mx_switch",
          "defaultColor": "#dc2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": 20,
          "export_stl": true
        }
      ]
    },
    {
      "id": "keycap",
      "label": "20.11 Keycap",
      "name": "20.11 Keycap",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 30,
      "parts": [
        {
          "id": "keycap",
          "label": "Round Keycap",
          "name": "Round Keycap",
          "groupId": 2,
          "colorKey": "keycap",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 30,
          "export_stl": true
        }
      ]
    },
    {
      "id": "teacher_decoration",
      "label": "20.11 Decoration",
      "name": "20.11 Decoration",
      "color": "#123B63",
      "assembled_z_offset": 0,
      "exploded_z_offset": 40,
      "parts": [
        {
          "id": "teacher_decoration",
          "label": "Text, Book and Flowers",
          "name": "Text, Book and Flowers",
          "groupId": 3,
          "colorKey": "teacher_decoration",
          "defaultColor": "#123B63",
          "assembled_z_offset": 0,
          "exploded_z_offset": 40,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full 20.11 Clicker"
    },
    {
      "id": "0",
      "label": "Download STL - Clicker Base"
    },
    {
      "id": "1",
      "label": "Download STL - MX Switch"
    },
    {
      "id": "2",
      "label": "Download STL - Keycap"
    },
    {
      "id": "3",
      "label": "Download STL - 20.11 Decoration"
    }
  ]
};
